// Custom theme overrides and client-specific behavior
// Keep this file for customizations to ease theme updates.

(function(){
  'use strict';

  var BaseModalElement = (window.customElements && (window.customElements.get('basic-modal') || window.customElements.get('modal-component'))) || null;
  if (BaseModalElement && !window.customElements.get('stock-limit-modal')) {
    var StockLimitModalElement = class extends BaseModalElement {
      connectedCallback() {
        if (super.connectedCallback) {
          super.connectedCallback();
        }
        var self = this;
        if (!this._stockLimitCloseHandler) {
          this._stockLimitCloseHandler = function(event) {
            if (event.target.closest('[data-stock-limit-close]')) {
              event.preventDefault();
              self.hide();
            }
          };
        }
        this.addEventListener('click', this._stockLimitCloseHandler);

        if (!this._stockLimitOverlayHandler) {
          this._stockLimitOverlayHandler = function(event) {
            if (event.target.classList.contains('fixed-overlay')) {
              event.preventDefault();
              self.hide();
            }
          };
        }
        if (this.overlay) {
          this.overlay.addEventListener('click', this._stockLimitOverlayHandler);
        }
      }

      disconnectedCallback() {
        if (this._stockLimitCloseHandler) {
          this.removeEventListener('click', this._stockLimitCloseHandler);
        }
        if (this._stockLimitOverlayHandler && this.overlay) {
          this.overlay.removeEventListener('click', this._stockLimitOverlayHandler);
        }
        if (super.disconnectedCallback) {
          super.disconnectedCallback();
        }
      }

      get focusElement() {
        return this.querySelector('[data-stock-limit-primary]') || super.focusElement;
      }
    };

    window.customElements.define('stock-limit-modal', StockLimitModalElement);
  }

  var StockLimitModalManager = {
    awaitingDom: false,
    cartErrorSubscribed: false,
    modal: null,
    productContainer: null,
    productValueEl: null,
    systemContainer: null,
    systemValueEl: null,
    titleEl: null,
    bodyEl: null,
    defaultBodyText: '',
    defaultTitleText: '',
    primaryButton: null,
  };

  StockLimitModalManager.init = function(force) {
    if (this.modal && !force) return true;
    this.modal = document.getElementById('StockLimitModal');
    if (!this.modal) {
      if (!this.awaitingDom) {
        this.awaitingDom = true;
        document.addEventListener(
          'DOMContentLoaded',
          function(){
            StockLimitModalManager.init(true);
          },
          { once: true }
        );
      }
      return false;
    }

    this.productContainer = this.modal.querySelector('[data-stock-limit-product]');
    this.productValueEl = this.modal.querySelector('[data-stock-limit-product-text]');
    this.systemContainer = this.modal.querySelector('[data-stock-limit-system]');
    this.systemValueEl = this.modal.querySelector('[data-stock-limit-system-text]');
    this.titleEl = this.modal.querySelector('[data-stock-limit-title]');
    this.bodyEl = this.modal.querySelector('[data-stock-limit-body]');
    this.primaryButton = this.modal.querySelector('[data-stock-limit-primary]');
    this.defaultBodyText = this.bodyEl ? this.bodyEl.textContent.trim() : '';
    this.defaultTitleText = this.titleEl ? this.titleEl.textContent.trim() : '';
    this.initCartErrorSubscription();
    return true;
  };

  StockLimitModalManager.initCartErrorSubscription = function() {
    if (this.cartErrorSubscribed) return;
    if (!window.FoxTheme || !FoxTheme.pubsub) return;
    this.cartErrorSubscribed = true;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, function(payload){
      var message = payload && (payload.errors || payload.message);
      var productTitle = payload && payload.productTitle;
      StockLimitModalManager.maybeShow(message, {
        source: payload && payload.source,
        productTitle: productTitle,
      });
    });
  };

  StockLimitModalManager.sanitizeMessage = function(rawMessage) {
    if (!rawMessage) return '';
    if (typeof rawMessage === 'string') return this.stripHtml(rawMessage);
    if (Array.isArray(rawMessage)) return this.sanitizeMessage(rawMessage.join(' '));
    if (typeof rawMessage === 'object') return this.sanitizeMessage(Object.values(rawMessage).join(' '));
    return '';
  };

  StockLimitModalManager.stripHtml = function(value) {
    var buffer = document.createElement('div');
    buffer.innerHTML = value;
    return (buffer.textContent || buffer.innerText || '').replace(/\s+/g, ' ').trim();
  };

  StockLimitModalManager.extractQuantity = function(message) {
    if (!message) return null;
    var match = message.match(/(\d{1,4})\s*(?:stk|stykker|varer|enheder)?/i);
    if (!match) return null;
    var value = parseInt(match[1], 10);
    return isNaN(value) ? null : value;
  };

  StockLimitModalManager.formatQuantityLabel = function(quantity) {
    if (!quantity) return '';
    return quantity + ' stk';
  };

  StockLimitModalManager.updateContent = function(systemMessage, context) {
    context = context || {};
    var derivedQuantity = context.quantity || this.extractQuantity(systemMessage);
    var quantityLabel = this.formatQuantityLabel(derivedQuantity);

    if (this.titleEl) {
      if (quantityLabel) {
        this.titleEl.textContent = 'Kun ' + quantityLabel + ' tilføjet til kurven';
      } else if (this.defaultTitleText) {
        this.titleEl.textContent = this.defaultTitleText;
      }
    }
    if (this.bodyEl) {
      if (quantityLabel) {
        this.bodyEl.textContent = 'Vi kunne kun tilføje ' + quantityLabel + ' lige nu. Resten er ikke tilgængelige.';
      } else if (this.defaultBodyText) {
        this.bodyEl.textContent = this.defaultBodyText;
      }
    }
    if (this.productContainer && this.productValueEl) {
      var title = (context.productTitle || '').trim();
      this.productContainer.hidden = !title;
      this.productValueEl.textContent = title;
    }
    if (this.systemContainer && this.systemValueEl) {
      this.systemContainer.hidden = !systemMessage;
      this.systemValueEl.textContent = systemMessage;
    }
  };

  StockLimitModalManager.openModal = function() {
    if (!this.modal) return;
    if (typeof this.modal.show === 'function') {
      this.modal.show(this.primaryButton || null);
    } else {
      this.modal.removeAttribute('hidden');
      this.modal.setAttribute('open', '');
      var focusTarget = this.primaryButton || this.modal.querySelector('[data-stock-limit-close]');
      if (focusTarget) {
        focusTarget.focus();
      }
    }
  };

  StockLimitModalManager.maybeShow = function(message, context) {
    context = context || {};
    if (!this.init()) return false;
    var cleanMessage = this.sanitizeMessage(message);
    this.updateContent(cleanMessage, context);
    this.openModal();
    return true;
  };

  window.StockLimitModalManager = StockLimitModalManager;

  // Sanitize Odoo bilag links in product "Dokumenter" accordion
  function sanitizeBilag() {
    var lists = document.querySelectorAll('.odoo-bilag');
    lists.forEach(function(ul){
      var links = ul.querySelectorAll('a.bilag-link, a');
      links.forEach(function(link){
        var url = (link.getAttribute('data-url') || link.getAttribute('href') || '').trim();
        var lower = url.toLowerCase();
        var isFile = /\.(pdf|docx?|xlsx?|pptx?)(?:$|[?#])/i.test(lower);
        var hasProtocol = /^(https?:)?\/\//i.test(url);
        var isCdn = lower.indexOf('/cdn/') !== -1 || lower.indexOf('/files/') !== -1;
        var isValid = hasProtocol || isCdn || isFile;

        if (!isValid) {
          var li = link.closest('li');
          if (li) li.remove();
          return;
        }

        if (isFile) {
          var name = decodeURIComponent(url.split('/').pop().split('?')[0]).replace(/[\-_]+/g, ' ').trim();
          link.textContent = name || url;
          return;
        }

        // Fetch HTML title for non-file URLs
        fetch(url)
          .then(function(res){
            var ct = (res.headers.get('content-type') || '').toLowerCase();
            if (ct.indexOf('text/html') === -1) throw new Error('non-html');
            return res.text();
          })
          .then(function(html){
            var match = html.match(/<title>(.*?)<\/title>/i);
            link.textContent = (match && match[1]) ? match[1].trim() : url;
          })
          .catch(function(){
            var fallback = decodeURIComponent(url.split('/').pop().split('?')[0]).replace(/[\-_]+/g, ' ').trim();
            if (!link.textContent || link.textContent === 'Indlæser titel...') link.textContent = fallback || url;
          });
      });

      if (!ul.querySelector('li')) ul.remove();
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    StockLimitModalManager.init(true);
    sanitizeBilag();
    setTimeout(sanitizeBilag, 100);

    // Mini ATC label: show '+' if text would overflow, with hysteresis to avoid flicker
    function updateMiniATCLabels(scope) {
      var container = scope || document;
      var buttons = container.querySelectorAll('.btn--mini-atc');

      // Re-usable hidden measurer for accurate text width
      if (!document.__miniAtcMeasurer) {
        var measurer = document.createElement('span');
        measurer.style.position = 'absolute';
        measurer.style.left = '-9999px';
        measurer.style.top = '-9999px';
        measurer.style.whiteSpace = 'nowrap';
        measurer.style.visibility = 'hidden';
        document.body.appendChild(measurer);
        document.__miniAtcMeasurer = measurer;
      }
      var measurer = document.__miniAtcMeasurer;

      buttons.forEach(function(btn){
        var span = btn.querySelector('.btn__text');
        if (!span) return;

        // Persist original label
        var fullText = span.getAttribute('data-full-text') || span.textContent;
        if (!span.getAttribute('data-full-text')) span.setAttribute('data-full-text', fullText);

        // Available inner width inside the button (excluding padding)
        var csBtn = window.getComputedStyle(btn);
        var padX = parseFloat(csBtn.paddingLeft) + parseFloat(csBtn.paddingRight);
        var avail = Math.max(0, btn.clientWidth - padX);

        // Measure full label width using hidden measurer with same font styles
        var csSpan = window.getComputedStyle(span);
        measurer.style.font = csSpan.font; // includes font-style, variant, weight, size/line-height, family
        measurer.style.letterSpacing = csSpan.letterSpacing;
        measurer.style.textTransform = csSpan.textTransform;
        measurer.textContent = fullText;
        var fullWidth = measurer.offsetWidth;

        // Hysteresis thresholds (px): enter compact sooner, exit compact later
        var ENTER_MARGIN = 8;   // become '+' a bit before true overflow
        var EXIT_MARGIN = 20;   // require extra space to restore text

        var isCompact = btn.classList.contains('btn--mini-atc--compact');
        var wantCompact = isCompact ? (avail < fullWidth + EXIT_MARGIN ? true : false)
                                     : (avail < fullWidth + ENTER_MARGIN ? true : false);

        // Throttle rapid toggles
        var now = performance.now();
        var lastToggle = btn.__miniAtcLastToggle || 0;
        var canToggle = (now - lastToggle) > 200; // ms

        if (wantCompact !== isCompact && canToggle) {
          btn.__miniAtcLastToggle = now;
          if (wantCompact) {
            span.textContent = '+';
            btn.classList.add('btn--mini-atc--compact');
            if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', fullText);
          } else {
            span.textContent = fullText;
            btn.classList.remove('btn--mini-atc--compact');
            btn.removeAttribute('aria-label');
          }
        }
      });
    }

    // Initial run and on resize
    var rafId;
    function scheduleUpdate(){
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function(){ updateMiniATCLabels(); });
    }
    // Run immediately to avoid any visible truncation, then a couple of rAF passes
    updateMiniATCLabels();
    scheduleUpdate();
    requestAnimationFrame(scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate);

    // Observe product card sliders/lazy render
    var ro = new ResizeObserver(function(){ scheduleUpdate(); });
    document.querySelectorAll('.product-card__mini-form').forEach(function(el){ ro.observe(el); });
  });
})();


/* App overwrites */
const rmtb = () => {
  const elements = document.querySelectorAll(
    "div.MagicToolboxContainer span a"
  );

  elements.forEach(el => {
    if (el.textContent.toLowerCase().includes("trial version")) {
      el.remove();
    }
  });
};

// First cleanup on page load
rmtb();

// Observe future changes
const observer = new MutationObserver(() => rmtb());

observer.observe(document.body, {
  childList: true,
  subtree: true
});
